import { FieldErrors, UseFormRegisterReturn } from "react-hook-form";
import { TextInput, Label } from "flowbite-react";
import { MdEmail } from "react-icons/md";

interface EmailInputProps {
    id: string;
    label: string;
    placeholder: string;
    register: UseFormRegisterReturn;
    errors?: FieldErrors;
}

const EmailInput = ({ id, label, placeholder, register, errors }: EmailInputProps) => {
    return (
        <div className='mb-4 pl-1 py-2 '>
            <Label htmlFor={id} className='py-1 px-2 block text-gray-300 lg:text-gray-700'>
                {label}
            </Label>
            <div className='flex flex-row items-center gap-4 pr-3'>
                <TextInput
                    id={id}
                    type='email'
                    {...register}
                    placeholder={placeholder}
                    className='w-full border-none '
                    style={{ boxShadow: "none", border: 0 }}
                />
                <MdEmail className='text-gray-300 lg:text-gray-700' size={24} />
            </div>
            {errors && errors[id] && (
                <p className='px-2 text-xs font-light text-red-600'>{(errors[id]?.message as string) || "Error"}</p>
            )}
        </div>
    );
};

export default EmailInput;